import MTelephoneNumber from "./MTelephoneNumber.vue";
export default MTelephoneNumber;
